//@ts-nocheck
import React, { useEffect, useMemo, useState } from 'react';
import {
    Box,
    Typography,
    Paper,
    Button,
    IconButton,
    Select,
    MenuItem,
    Menu,
    InputLabel,
    FormControl,
    TextField,
    Chip,
    createTheme,
    ThemeProvider,
    Autocomplete,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    useMediaQuery,
    CircularProgress,
    useTheme,
    Tooltip,
    Checkbox,
    Tabs,
    Tab
} from '@mui/material';
import { GoldBindingModal, InputControl, NumericFormatInputControl, DateTimePickerControl, DatePickerControl } from '../../molecules';
import {
    useGetMerchantAccountHistory, useGetMerchantsWithParentMerchant, useGetMerchantCurrentBalanceTypeSettingsList, useMerchantCurrentBalanceMovement, GetMerchantAccountHistoryListRequest, useGetMerchantWithLatestMovementDetail, PagingResponse, useAuthorization, useMerchantCurrentBalanceMovementUpdate, useMerchantCurrentBalanceMovementDelete, useConfirmationModal,
    useGetGoldBindingCumulativeTotal,
    useGetMerchantGoldBalance,
    useGetMerchantBalanceListByMerchant
} from '../../../hooks';
import { useSetSnackBar } from "../../../store/Snackbar.state";
import { Table } from '../../../components';
import {
    GridColDef,
    GridPaginationModel,
    GridValueFormatterParams,
} from "@mui/x-data-grid";
import dayjs from 'dayjs';
import { useForm } from 'react-hook-form';
import { MerchantAccoutFormValuesType, merchantAccoutSchema } from './_formTypes';
import { zodResolver } from '@hookform/resolvers/zod';
import { useLocation } from 'react-router-dom';
import { downloadExcel } from "../../../util/downloadExcel";
import { ViewSidebar, ViewSidebarOutlined } from '@mui/icons-material';
import { RequestFilterOperationTypeEnum, RequestFilterValueTypeEnums, mapReactMUIToFilterOperationTypes, mapReactFilterValueTypeToRequestFilterValueType } from '../../../common/enums/RequestFilterEnums';

import { Loading } from '../../../components';
import MoreVertOutlined from '@mui/icons-material/MoreVertOutlined';
import { useIsFetching } from 'react-query';
import * as z from 'zod';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import { m } from 'framer-motion';

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

interface TransactionStatus {
    id: number;
    key: string;
    value: string;
}

interface Merchant {
    id: number;
    merchantName: string;
    taxNumber: string;
    merchantId: number;
    parentMerchantId: number;
    status: string;
}

interface TableDataType {
    result: any[];
    totalItems: number;
}

const merchantGoldBindingSchema = z.object({
    startDate: z.instanceof(dayjs).nullable(),
    endDate: z.instanceof(dayjs).nullable(),
    merchantIds: z.any().nullable(),
});

type MerchantGoldBindingFormValuesType = z.infer<typeof merchantGoldBindingSchema>;

export const MerchantGoldBindingForm = ({ merchant }: any) => {
    const { handleSubmit, control, setValue, watch, formState: { errors }, getValues } =
        useForm<MerchantGoldBindingFormValuesType>({
            resolver: zodResolver(merchantGoldBindingSchema),
            defaultValues: {
                startDate: null,
                endDate: null,
                merchantIds: null
            },
        });

    const theme = useTheme();
    const { showDelete, showUpdate, showCreate } = useAuthorization();
    const { data: rawMerchantList, isLoading: isMerchantListLoading } = useGetMerchantsWithParentMerchant("ACTIVE");
    const [selectedMerchant, setSelectedMerchant] = useState<Merchant | null>(null);
    const [transactionType, setTransactionType] = useState<number>(1);
    const [amount, setAmount] = useState<number>(0);
    const [description, setDescription] = useState<string>('');
    const [openModal, setOpenModal] = useState(false);
    const { mutate: merchantCurrentBalanceMovement, isLoading: merchantCurrentBalanceMovementLoading } = useMerchantCurrentBalanceMovement();
    const { mutate: getMerchantGoldBindingFormHistoryListMutation, isLoading } = useGetMerchantAccountHistory();

    // MARK : Gold
    const { mutate: getGoldBindingCumulativeTotal, isLoading: isGoldBindingCumulativeTotalLoading } = useGetGoldBindingCumulativeTotal();
    const { mutate: getMerchantGoldBalance, isLoading: isGetMerchantGoldBalanceLoading } = useGetMerchantGoldBalance();

    const [movementDetail, setMovementDetail] = useState<any>({});
    const [selectedType, setSelectedType] = useState<any>(null);
    const [selectedTypeChanged, setSelectedTypeChanged] = useState<any>(null);

    const [modalMode, setModalMode] = useState<'insert' | 'update'>('insert');
    const [selectedRow, setSelectedRow] = useState<any>(null);

    const [startDate, setStartDate] = useState<Date | null>(null);
    const [endDate, setEndDate] = useState<Date | null>(null);

    const { mutate: merchantCurrentBalanceDelete } = useMerchantCurrentBalanceMovementDelete();
    const { showConfirmationModal } = useConfirmationModal();

    const [selectedMerchants, setSelectedMerchants] = useState<Merchant[]>([]);

    const setSnackbar = useSetSnackBar();
    interface QueryOptions {
        field?: string;
        value?: any;
        clearFilter?: boolean;
        [key: string]: string | number | boolean | undefined | any;
    }

    const [queryOptions, setQueryOptions] = React.useState<QueryOptions>({});
    const [paginationModel, setPaginationModel] = useState<GridPaginationModel>({
        page: 0,
        pageSize: 25,
    });
    const { data: rawTransactionStatusList } = useGetMerchantCurrentBalanceTypeSettingsList({});

    const [tableData, setTableData] = useState<PagingResponse<Array<any>>>();
    const isDesktop = useMediaQuery(theme.breakpoints.up("md"));
    const location = useLocation();
    const [mercantIdentification, setMercantIdentification] = useState<boolean>(false);
    const [dynamicFilters, setDynamicFilter] = useState<any>([]);
    const [selectedCurrency, setSelectedCurrency] = useState<string>('TRY');
    const [isInitialLoad, setIsInitialLoad] = useState(true); // İlk yükleme kontrolü

    const [activeTab, setActiveTab] = useState<number>(0);

    const { mutate: getMerchantBalanceListByMerchant, isLoading: isMerchantBalanceListLoading } = useGetMerchantBalanceListByMerchant();
    const [tableDataSecondTab, setTableDataSecondTab] = useState<PagingResponse<Array<any>>>();
    const [paginationModelSecondTab, setPaginationModelSecondTab] = useState<GridPaginationModel>({
        page: 0,
        pageSize: 25,
    });
    const [isInitialLoadSecondTab, setIsInitialLoadSecondTab] = useState(true);
    const [hasSecondTabBeenOpened, setHasSecondTabBeenOpened] = useState(false); // İkinci tab hiç açıldı mı?

    var isPageLoading = isMerchantListLoading ||
        merchantCurrentBalanceMovementLoading ||
        isGoldBindingCumulativeTotalLoading ||
        isLoading ||
        isMerchantBalanceListLoading;

    // useEffect(() => {
    //     if (!selectedMerchant) {
    //         return;
    //     }
    //     getGoldBindingCumulativeTotal(
    //         { startDate: '2000-06-30T21:00:00.000Z', endDate: dayjs().endOf('month').toDate(), page: paginationModel.page, size: paginationModel.pageSize },
    //         {
    //             onSuccess: (data) => {
    //                 setMovementDetail(data?.data);
    //             },
    //             onError: () => {
    //                 setSnackbar({
    //                     severity: "error",
    //                     description: "İşlem sırasında bir hata oluştu",
    //                     isOpen: true,
    //                 });
    //             },
    //         }
    //     );

    // }, [selectedMerchant, getGoldBindingCumulativeTotal, selectedCurrency])

    useEffect(() => {

    }, [selectedMerchant]);

    /*     useEffect(() => {
            if (selectedMerchant && !mercantIdentification) {
                localStorage.setItem('selectedMerchant', JSON.stringify(selectedMerchant));
            } else {
                localStorage.removeItem('selectedMerchant');
            }
        }, [selectedMerchant]); */

    useEffect(() => {
        if (activeTab !== 1) {
            return;
        }

        if (!hasSecondTabBeenOpened) {
            setHasSecondTabBeenOpened(true);
        }

        const merchantId = localStorage.getItem('merchantId');
        const merchantIdNum = merchantId && merchantId !== '0' ? parseInt(merchantId) : null;
        const formValues = getValues();

        const requestPayload: any = {
            size: paginationModelSecondTab.pageSize,
            page: (paginationModelSecondTab.page || 0) + 1,
            orderBy: "CreateDate",
            orderByDesc: true,
            ...queryOptions,
        };

        if (selectedMerchants.length > 0) {
            requestPayload.merchantIds = selectedMerchants.map(m => m.merchantId).join(',');
        } else if (merchantIdNum) {
            requestPayload.merchantIds = merchantIdNum.toString();
        }

        if (!isInitialLoadSecondTab) {
            requestPayload.filters = dynamicFilters || [];

            const queryParams = getQueryParams(queryOptions);

            const startDate = watch('startDate');
            const endDate = watch('endDate');
            if (startDate && endDate) {
                const startDateLocal = startDate.hour(0).minute(0).second(0).millisecond(0);
                const endDateLocal = endDate.hour(23).minute(59).second(59).millisecond(999);
                requestPayload.CreateDateStart = startDateLocal.format('YYYY-MM-DDTHH:mm:ss.SSS') + 'Z';
                requestPayload.CreateDateEnd = endDateLocal.format('YYYY-MM-DDTHH:mm:ss.SSS') + 'Z';
            }

            Object.assign(requestPayload, queryParams);

            if (queryOptions?.field && queryOptions?.value !== undefined) {
                requestPayload[queryOptions.field] = queryOptions.value;
            }
        }


        getMerchantBalanceListByMerchant(
            requestPayload,
            {
                onSuccess: (data) => {

                    if (data.isSuccess) {
                        setTableDataSecondTab(data?.data);
                        if (isInitialLoadSecondTab) {
                            setIsInitialLoadSecondTab(false);
                        }
                    } else {
                        setSnackbar({
                            severity: "error",
                            description: data.message,
                            isOpen: true,
                        });
                    }
                },
                onError: () => {
                    setSnackbar({
                        severity: "error",
                        description: "İşlem sırasında bir hata oluştu",
                        isOpen: true,
                    });
                },
            }
        );
    }, [
        activeTab,
        paginationModelSecondTab.page,
        paginationModelSecondTab.pageSize,
        queryOptions
    ]);

    const handleSearch = () => {
        if (activeTab === 0) {
            const requestPayload: any = {
                size: paginationModel.pageSize,
                page: 0,
                orderBy: "CreateDate",
                orderByDesc: true,
                filters: dynamicFilters || [],
            };

            const startDate = watch('startDate');
            const endDate = watch('endDate');
            if (startDate && endDate) {
                const startDateLocal = startDate.hour(0).minute(0).second(0).millisecond(0);
                const endDateLocal = endDate.hour(23).minute(59).second(59).millisecond(999);
                requestPayload.startDate = startDateLocal.format('YYYY-MM-DDTHH:mm:ss.SSS') + 'Z';
                requestPayload.endDate = endDateLocal.format('YYYY-MM-DDTHH:mm:ss.SSS') + 'Z';
            } else {
                requestPayload.startDate = '1900-01-01T00:00:00.000Z';
                const todayEnd = dayjs().hour(23).minute(59).second(59).millisecond(999);
                requestPayload.endDate = todayEnd.format('YYYY-MM-DDTHH:mm:ss.SSS') + 'Z';
            }

            const queryParams = getQueryParams(queryOptions);
            Object.assign(requestPayload, queryParams);

            if (queryOptions?.field && queryOptions?.value !== undefined) {
                requestPayload[queryOptions.field] = queryOptions.value;
            }

            if (selectedMerchants.length > 0) {
                requestPayload.merchantIds = selectedMerchants.map(m => m.merchantId).join(',');
            }

            getGoldBindingCumulativeTotal(
                requestPayload,
                {
                    onSuccess: (data) => {
                        if (data.isSuccess) {
                            setTableData(data?.data);
                            setPaginationModel({ page: 0, pageSize: paginationModel.pageSize });
                        } else {
                            setSnackbar({
                                severity: "error",
                                description: data.message,
                                isOpen: true,
                            });
                        }
                    },
                    onError: () => {
                        setSnackbar({
                            severity: "error",
                            description: "İşlem sırasında bir hata oluştu",
                            isOpen: true,
                        });
                    },
                }
            );
        } else {
            const merchantId = localStorage.getItem('merchantId');
            const merchantIdNum = merchantId && merchantId !== '0' ? parseInt(merchantId) : null;

            const requestPayload: any = {
                size: paginationModelSecondTab.pageSize,
                page: 1,
                orderBy: "CreateDate",
                orderByDesc: true,
                filters: dynamicFilters || [],
            };

            const startDate = watch('startDate');
            const endDate = watch('endDate');
            if (startDate && endDate) {
                const startDateLocal = startDate.hour(0).minute(0).second(0).millisecond(0);
                const endDateLocal = endDate.hour(23).minute(59).second(59).millisecond(999);
                requestPayload.CreateDateStart = startDateLocal.format('YYYY-MM-DDTHH:mm:ss.SSS') + 'Z';
                requestPayload.CreateDateEnd = endDateLocal.format('YYYY-MM-DDTHH:mm:ss.SSS') + 'Z';
            }

            const queryParams = getQueryParams(queryOptions);
            Object.assign(requestPayload, queryParams);

            if (selectedMerchants.length > 0) {
                requestPayload.merchantIds = selectedMerchants.map(m => m.merchantId).join(',');
            } else if (merchantIdNum) {
                requestPayload.merchantIds = merchantIdNum.toString();
            }

            if (queryOptions?.field && queryOptions?.value !== undefined) {
                requestPayload[queryOptions.field] = queryOptions.value;
            }

            getMerchantBalanceListByMerchant(
                requestPayload,
                {
                    onSuccess: (data) => {
                        if (data.isSuccess) {
                            setTableDataSecondTab(data?.data);
                            setPaginationModelSecondTab({ page: 0, pageSize: paginationModelSecondTab.pageSize });
                        } else {
                            setSnackbar({
                                severity: "error",
                                description: data.message,
                                isOpen: true,
                            });
                        }
                    },
                    onError: () => {
                        setSnackbar({
                            severity: "error",
                            description: "İşlem sırasında bir hata oluştu",
                            isOpen: true,
                        });
                    },
                }
            );
        }
    };

    const debounce = (func: (...args: any[]) => void, delay: number) => {
        let timeoutId: NodeJS.Timeout;
        return (...args: any[]) => {
            clearTimeout(timeoutId);
            timeoutId = setTimeout(() => {
                func.apply(null, args);
            }, delay);
        };
    };

    interface FilterParams {
        [key: string]: string | number | boolean | null | undefined;
    }

    // MerchantListingTable'daki gibi, filtreleri doğru tipte payload'a ekle
    const getQueryParams = (filters: FilterParams) => {
        const queryParams: { [key: string]: string | number | boolean | null } = {};
        if (filters.MinAmount !== undefined && filters.MinAmount !== null && filters.MinAmount !== "") {
            queryParams.MinAmount = Number(filters.MinAmount);
        }
        if (filters.MaxAmount !== undefined && filters.MaxAmount !== null && filters.MaxAmount !== "") {
            queryParams.MaxAmount = Number(filters.MaxAmount);
        }
        // Para birimi kodlarını sayısal değerlere dönüştür
        const currencyMap: Record<string, string> = {
            'TRY': '949',
            'USD': '840',
            'EUR': '978',
            '949': '949',
            '840': '840',
            '978': '978'
        };

        // Currency veya currency parametresini kontrol et ve sayısal koda dönüştür
        const currencyValue = filters.Currency || filters.currency;
        if (currencyValue !== undefined && currencyValue !== null && currencyValue !== "") {
            const val = String(currencyValue).toUpperCase();
            const currencyCode = currencyMap[val];
            if (currencyCode) {
                queryParams.currency = currencyCode;
            }
        }
        if (filters.Description !== undefined && filters.Description !== null && filters.Description !== "") {
            queryParams.Description = String(filters.Description);
        }
        if (filters.MerchantCurrentBalanceType !== undefined && filters.MerchantCurrentBalanceType !== null && filters.MerchantCurrentBalanceType !== "") {
            queryParams.MerchantCurrentBalanceType = Number(filters.MerchantCurrentBalanceType);
        }
        if (filters.MerchantCurrentBalanceTypeId !== undefined && filters.MerchantCurrentBalanceTypeId !== null && filters.MerchantCurrentBalanceTypeId !== "") {
            queryParams.MerchantCurrentBalanceTypeId = Number(filters.MerchantCurrentBalanceTypeId);
        }

        // Sadece createDate için ISO dateTime formatına çevir
        if (filters.createDate !== undefined && filters.createDate !== null && filters.createDate !== "") {
            const date = new Date(filters.createDate);
            if (!isNaN(date.getTime())) {
                const startDate = new Date(date);
                startDate.setHours(0, 0, 0, 0);
                queryParams.CreateDateStart = startDate.toISOString();

                const endDate = new Date(date);
                endDate.setHours(23, 59, 59, 999);
                queryParams.CreateDateEnd = endDate.toISOString();
            }
        }

        // Diğer filtreler için eski mantık
        for (let key in filters) {
            if (
                ![
                    "MinAmount",
                    "MaxAmount",
                    "Currency",
                    "Description",
                    "MerchantCurrentBalanceType",
                    "MerchantCurrentBalanceTypeId",
                    "CreateDateStart",
                    "CreateDateEnd",
                    "createDate"
                ].includes(key)
            ) {
                if (filters[key] !== undefined && filters[key] !== null && filters[key] !== "") {
                    queryParams[key] = filters[key];
                }
            }
        }
        return queryParams;
    };

    const handleFilterChange = debounce((filters, tableFilters) => {
        if (filters.clearFilter) {
            localStorage.removeItem('merchantListingTableFilter')
            setQueryOptions({});
            return;
        }

        // Amount filtresini minAmount ve maxAmount olarak ayırdık (yapı öyle çünkü)
        if (filters.amount !== undefined && filters.amount !== null && filters.amount !== "") {
            filters.MinAmount = filters.amount;
            filters.MaxAmount = filters.amount;
            delete filters.amount;
        }

        const queryParams = getQueryParams(filters);

        const isValueValid = (key: string, value: any): boolean => {
            if (key === 'MinAmount' || key === 'MaxAmount') {
                return value !== undefined && value !== null && !isNaN(Number(value));
            }
            return value !== undefined && value !== null && value.toString().length >= 3;
        }

        const allValuesValid = Object.entries(queryParams).every(([key, value]) => isValueValid(key, value));
        const previousKeysLength = Object.keys(previousQueryParams.current).length;
        const currentKeysLength = Object.keys(queryParams).length;

        if (JSON.stringify(previousQueryParams.current) === JSON.stringify(queryParams)) {
            return;
        }

        if (allValuesValid || (previousKeysLength > currentKeysLength)) {
            setQueryOptions(queryParams);
        }

        previousQueryParams.current = queryParams;
    }, 500);
    const hasActiveFilters = Object?.keys(queryOptions)?.length > 0;
    // Komponent içerisinde
    const previousQueryParams = React.useRef({});

    const [menuAnchorEl, setMenuAnchorEl] = useState<{ [key: string]: HTMLElement | null }>({});

    // Modify handleRowUpdate function
    const handleRowUpdate = (params: any) => {
        setModalMode('update');
        setSelectedRow(params.row);
        // Pre-fill form data
        setValue('transactionType', params.row.merchantCurrentBalanceTypeId);
        setValue('amount', params.row.amount);
        setValue('description', params.row.explain?.split('/')[1]?.trim());
        setOpenModal(true);
        setMenuAnchorEl({});
    };

    const columns: GridColDefExt[] = useMemo(() => {
        return [
            {
                field: 'merchantName',
                headerName: 'Müşteri Adı',
                width: 200,
                columnType: RequestFilterValueTypeEnums.STRING,
                flex: 1
            },
            {
                field: 'sumAmount',
                headerName: 'Toplam Tutar',
                width: 150,
                type: 'decimal',
                valueFormatter: (params: GridValueFormatterParams<number>) =>
                    params.value?.toLocaleString('tr-TR', {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                    }),
                columnType: RequestFilterValueTypeEnums.NUMBER
            },
            {
                field: 'sumCredit',
                headerName: 'Toplam Alacak',
                width: 150,
                type: 'decimal',
                valueFormatter: (params: GridValueFormatterParams<number>) =>
                    params.value?.toLocaleString('tr-TR', {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                    }),
                columnType: RequestFilterValueTypeEnums.NUMBER
            },
            {
                field: 'sumDebt',
                headerName: 'Toplam Borç',
                width: 150,
                type: 'decimal',
                valueFormatter: (params: GridValueFormatterParams<number>) =>
                    params.value?.toLocaleString('tr-TR', {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                    }),
                columnType: RequestFilterValueTypeEnums.NUMBER
            },
            {
                field: 'currencyCode',
                headerName: 'Para Birimi',
                width: 120,
                columnType: RequestFilterValueTypeEnums.STRING
            },
            {
                field: 'merchantCurrentBalanceType',
                headerName: 'İşlem Tipi',
                width: 150,
                columnType: RequestFilterValueTypeEnums.STRING
            }
        ];
    }, [menuAnchorEl, showUpdate, showDelete]);

    const RenderCurrency = (props: GridRenderCellParams<any, string>) => {
        const { value } = props;

        const renderMoney = (money: string) => {
            switch (money) {
                case "949":
                    return "TRY";
                case "840":
                    return "USD";
                case "978":
                    return "EUR";
                default:
                    return money;
            }
        };

        return <>{renderMoney(value)}</>;
    };

    const columnsSecondTab: GridColDefExt[] = useMemo(() => {
        return [
            {
                field: 'merchantId',
                headerName: 'İşyeri No',
                width: 150,
                columnType: RequestFilterValueTypeEnums.NUMBER
            },
            {
                field: 'merchantName',
                headerName: 'İşyeri Adı',
                width: 300,
                columnType: RequestFilterValueTypeEnums.STRING,
                flex: 1
            },
            {
                field: "createDate",
                headerName: "Oluşturulma Tarihi",
                width: 200,
                type: 'date',
                valueGetter: (params) => params.value ? new Date(params.value) : null,
                columnType: RequestFilterValueTypeEnums.DATE,
                renderCell: (params) => {
                    if (!params.value) return "";
                    const formattedDate = dayjs(params.value).format("DD.MM.YYYY HH:mm");
                    if (formattedDate === "Invalid Date") return "";
                    return formattedDate;
                }
            },
            {
                field: 'description',
                headerName: 'Açıklama',
                width: 300,
                columnType: RequestFilterValueTypeEnums.STRING,
                flex: 1
            },
            {
                field: 'amount',
                headerName: 'Tutar',
                width: 150,
                type: 'decimal',
                valueFormatter: (params: GridValueFormatterParams<number>) =>
                    params.value?.toLocaleString('tr-TR', {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                    }),
                columnType: RequestFilterValueTypeEnums.NUMBER
            },
            {
                field: 'currency',
                headerName: 'Para Birimi',
                width: 120,
                columnType: RequestFilterValueTypeEnums.STRING,
                renderCell: RenderCurrency,
                type: 'singleSelect',
                valueOptions: [
                    { value: '949', label: 'TRY' },
                    { value: '840', label: 'USD' },
                    { value: '978', label: 'EUR' }
                ]
            },
            {
                field: "erpCustomerCode",
                headerName: "ERP İşyeri Kodu",
                width: 180
            },
        ];
    }, []);

    const convertTableFiltersToRequestFilter = (tableFilters: any) => {
        let convertedFilters: any = [];

        const currencyMap: Record<string, string> = {
            'TRY': '949',
            'USD': '840',
            'EUR': '978',
            'try': '949',
            'usd': '840',
            'eur': '978'
        };

        tableFilters.items.map((item: any) => {
            var findColumn = columns.find(x => x.field == item.field);
            let value = item.value;

            // Para birimi alanı için mapleme
            if (item.field === 'currency' || item.field === 'Currency') {
                value = currencyMap[value.toLowerCase()] || value;
            }

            convertedFilters.push({
                field: item.field,
                values: [value.toString()],
                valueType: mapReactFilterValueTypeToRequestFilterValueType(value, findColumn?.columnType),
                operationType: mapReactMUIToFilterOperationTypes(item.operator)
            });
        });

        return convertedFilters;
    }

    const handleChangePagination = (model: GridPaginationModel) => {
        setPaginationModel(model);
    };

    const handleChangePaginationSecondTab = (model: GridPaginationModel) => {
        setPaginationModelSecondTab(model);
    };

    function fieldValue(data: any[]): Record<string, string | number | undefined>[] {
        return data.map((item) => {
            return {
                'Müşteri Adı': item?.merchantName,
                'Toplam Tutar': item?.sumAmount?.toLocaleString('tr-TR', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                }),
                'Toplam Alacak': item?.sumCredit?.toLocaleString('tr-TR', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                }),
                'Toplam Borç': item?.sumDebt?.toLocaleString('tr-TR', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                }),
                'Para Birimi': item?.currencyCode,
                'İşlem Tipi': item?.merchantCurrentBalanceType
            };
        });
    }
    const onSave = () => {

        if (activeTab === 0) {
            const requestPayload: any = {
                size: tableData?.totalItems || 999999,
                page: paginationModel.page || 0,
                orderBy: "CreateDate",
                orderByDesc: true,
                filters: dynamicFilters || [],
                ...getQueryParams(queryOptions),
            };

            const startDate = watch('startDate');
            const endDate = watch('endDate');
            if (startDate && endDate) {
                const startDateLocal = startDate.hour(0).minute(0).second(0).millisecond(0);
                const endDateLocal = endDate.hour(23).minute(59).second(59).millisecond(999);
                requestPayload.startDate = startDateLocal.format('YYYY-MM-DDTHH:mm:ss.SSS') + 'Z';
                requestPayload.endDate = endDateLocal.format('YYYY-MM-DDTHH:mm:ss.SSS') + 'Z';
            } else {
                requestPayload.startDate = '1900-01-01T00:00:00.000Z';
                const todayEnd = dayjs().hour(23).minute(59).second(59).millisecond(999);
                requestPayload.endDate = todayEnd.format('YYYY-MM-DDTHH:mm:ss.SSS') + 'Z';
            }

            if (queryOptions?.field && queryOptions?.value !== undefined) {
                requestPayload[queryOptions.field] = queryOptions.value;
            }

            if (selectedMerchants.length > 0) {
                requestPayload.merchantIds = selectedMerchants.map(m => m.merchantId).join(',');
            }

            getGoldBindingCumulativeTotal(
                requestPayload,
                {
                    onSuccess: (data) => {
                        if (data.isSuccess) {

                            const refactoredData = fieldValue(data?.data?.result);
                            downloadExcel(refactoredData || [], "altın-bağlantı-raporu");
                        } else {
                            setSnackbar({
                                severity: "error",
                                description: data.message,
                                isOpen: true,
                            });
                        }
                    },
                    onError: () => {
                        setSnackbar({
                            severity: "error",
                            description: "İşlem sırasında bir hata oluştu",
                            isOpen: true,
                        });
                    },
                }
            );
        } else {
            const merchantId = localStorage.getItem('merchantId');
            const merchantIdNum = merchantId && merchantId !== '0' ? parseInt(merchantId) : null;

            const requestPayload: any = {
                size: tableDataSecondTab?.totalItems || 999999,
                page: 1,
                orderBy: "CreateDate",
                orderByDesc: true,
                filters: dynamicFilters || [],
            };

            const startDate = watch('startDate');
            const endDate = watch('endDate');
            if (startDate && endDate) {
                const startDateLocal = startDate.hour(0).minute(0).second(0).millisecond(0);
                const endDateLocal = endDate.hour(23).minute(59).second(59).millisecond(999);
                requestPayload.CreateDateStart = startDateLocal.format('YYYY-MM-DDTHH:mm:ss.SSS') + 'Z';
                requestPayload.CreateDateEnd = endDateLocal.format('YYYY-MM-DDTHH:mm:ss.SSS') + 'Z';
            }

            Object.assign(requestPayload, queryOptions);

            if (selectedMerchants.length > 0) {
                requestPayload.merchantIds = selectedMerchants.map(m => m.merchantId).join(',');
            } else if (merchantIdNum) {
                requestPayload.merchantIds = merchantIdNum.toString();
            }

            getMerchantBalanceListByMerchant(
                requestPayload,
                {
                    onSuccess: (data) => {
                        if (data.isSuccess) {
                            const refactoredData = data?.data?.result.map((item: any) => {
                                let currencyText = item.currency;
                                if (item.currency === '949') currencyText = 'TRY';
                                else if (item.currency === '840') currencyText = 'USD';
                                else if (item.currency === '978') currencyText = 'EUR';

                                return {
                                    'İşyeri No': item.merchantId,
                                    'İşyeri Adı': item.merchantName,
                                    'Oluşturulma Tarihi': dayjs(item.createDate).format("DD.MM.YYYY HH:mm"),
                                    'Açıklama': item.description,
                                    'Tutar': item.amount?.toLocaleString('tr-TR', {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2
                                    }),
                                    'Para Birimi': currencyText,
                                    'ERP İşyeri Kodu': item.erpCustomerCode
                                };
                            });
                            downloadExcel(refactoredData || [], "kalem-bazli-altin-islemleri");
                        } else {
                            setSnackbar({
                                severity: "error",
                                description: data.message,
                                isOpen: true,
                            });
                        }
                    },
                    onError: () => {
                        setSnackbar({
                            severity: "error",
                            description: "İşlem sırasında bir hata oluştu",
                            isOpen: true,
                        });
                    },
                }
            );
        }
    };

    const [isGoldBindingOpen, setGoldBindingOpen] = useState(false);

    // Modify the "İşlem Yap" button click handler
    const handleOpenGoldBindingModal = () => {
        setGoldBindingOpen(true);
    };

    useEffect(() => {
        if (isGoldBindingOpen === false && !isInitialLoad) {
            handleSearch();
        }
    }, [isGoldBindingOpen]);

    const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
        setActiveTab(newValue);

        if (newValue === 1 && !hasSecondTabBeenOpened) {
            setHasSecondTabBeenOpened(true);
        }
    };

    useEffect(() => {
        if (activeTab !== 0) return;

        const requestPayload: any = {
            size: paginationModel.pageSize,
            page: paginationModel.page || 0,
            orderBy: "CreateDate",
            orderByDesc: true,
        };

        if (!isInitialLoad) {
            requestPayload.filters = dynamicFilters || [];

            const queryParams = getQueryParams(queryOptions);
            Object.assign(requestPayload, queryParams);

            if (queryOptions?.field && queryOptions?.value !== undefined) {
                requestPayload[queryOptions.field] = queryOptions.value;
            }

            if (selectedMerchants.length > 0) {
                requestPayload.merchantIds = selectedMerchants.map(m => m.merchantId).join(',');
            }
        }

        const startDate = watch('startDate');
        const endDate = watch('endDate');
        if (startDate && endDate) {
            const startDateLocal = startDate.hour(0).minute(0).second(0).millisecond(0);
            const endDateLocal = endDate.hour(23).minute(59).second(59).millisecond(999);
            requestPayload.startDate = startDateLocal.format('YYYY-MM-DDTHH:mm:ss.SSS') + 'Z';
            requestPayload.endDate = endDateLocal.format('YYYY-MM-DDTHH:mm:ss.SSS') + 'Z';
        } else {
            requestPayload.startDate = '1900-01-01T00:00:00.000Z';
            const todayEnd = dayjs().hour(23).minute(59).second(59).millisecond(999);
            requestPayload.endDate = todayEnd.format('YYYY-MM-DDTHH:mm:ss.SSS') + 'Z';
        }

        getGoldBindingCumulativeTotal(
            requestPayload,
            {
                onSuccess: (data) => {
                    if (data.isSuccess) {
                        setTableData(data?.data);
                        if (isInitialLoad) {
                            setIsInitialLoad(false);
                        }
                    } else {
                        setSnackbar({
                            severity: "error",
                            description: data.message,
                            isOpen: true,
                        });
                    }
                },
                onError: () => {
                    setSnackbar({
                        severity: "error",
                        description: "İşlem sırasında bir hata oluştu",
                        isOpen: true,
                    });
                },
            }
        );
    }, [
        activeTab,
        paginationModel.page,
        paginationModel.pageSize,
    ]);

    return (

        <ThemeProvider theme={theme}>
            {isPageLoading && <Loading />}
            <Box className="p-4" sx={{ p: 2 }}>
                <Box
                    className="mb-6 bg-white rounded-lg shadow-lg overflow-hidden"
                    sx={{
                        mb: 3,
                        backgroundColor: '#FFF',
                        borderRadius: 2,
                        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                        border: '1px solid rgba(0, 0, 0, 0.05)'
                    }}>
                    <Box
                        className="p-6 flex justify-between items-center flex-wrap gap-4"
                        sx={{
                            p: 3,
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            flexWrap: 'wrap',
                            gap: 2,
                        }}>
                        <div className='flex gap-2'>
                            <Autocomplete<Merchant, true>
                                multiple
                                options={rawMerchantList?.data || []}
                                disableCloseOnSelect
                                getOptionLabel={(option) => option?.merchantName + ` ( ${option.merchantId} )` || ''}
                                renderOption={(props, option, { selected }) => (
                                    <li {...props}>
                                        <Checkbox
                                            icon={icon}
                                            checkedIcon={checkedIcon}
                                            style={{ marginRight: 8 }}
                                            checked={selected}
                                        />
                                        {option.merchantName} ({option.merchantId})
                                    </li>
                                )}
                                sx={{
                                    width: 350,
                                    minHeight: "56px !important",
                                    display: mercantIdentification ? 'none !important' : 'block',
                                    '& .MuiOutlinedInput-root': {
                                        borderRadius: '4px',
                                    }
                                }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Firma Seçiniz"
                                        placeholder={selectedMerchants.length === 0 ? "Seçiniz" : ""}
                                        InputProps={{
                                            ...params.InputProps,
                                            endAdornment: (
                                                <>
                                                    {isMerchantListLoading ? <CircularProgress color="inherit" size={20} /> : null}
                                                    {params.InputProps.endAdornment}
                                                </>
                                            ),
                                        }}
                                    />
                                )}
                                loading={isMerchantListLoading}
                                loadingText="Yükleniyor..."
                                filterOptions={(options, { inputValue }) => {
                                    return options.filter(option =>
                                        option.merchantName.toLowerCase().includes(inputValue.toLowerCase()) ||
                                        option.merchantId.toString().includes(inputValue)
                                    );
                                }}
                                isOptionEqualToValue={(option, value) => option.merchantId === value.merchantId}
                                value={selectedMerchants}
                                onChange={(event, newValue) => {
                                    setSelectedMerchants(newValue);
                                    const merchantIds = newValue.map(m => m.merchantId).join(',');
                                    setValue('merchantIds', merchantIds || null);
                                }}
                                onInputChange={(event, newInputValue) => {
                                    if (newInputValue === '') {
                                        setSelectedMerchants([]);
                                        setValue('merchantIds', null);
                                    }
                                }}
                                renderTags={(tagValue, getTagProps) =>
                                    tagValue.map((option, index) => (
                                        <Chip
                                            label={`${option.merchantName} (${option.merchantId})`}
                                            {...getTagProps({ index })}
                                            size="small"
                                        />
                                    ))
                                }
                                freeSolo={false}
                                disableListWrap
                                selectOnFocus
                                clearOnBlur
                                handleHomeEndKeys
                            />
                            <FormControl sx={{ flex: isDesktop ? 1 : "auto" }}>
                                <DatePickerControl
                                    sx={{ flex: 1 }}
                                    id="startDate"
                                    control={control}
                                    label="Başlangıç Tarihi"
                                    onChange={(date) => {
                                        setValue('startDate', date);
                                    }}
                                />
                            </FormControl>
                            <FormControl sx={{ flex: isDesktop ? 1 : "auto" }}>
                                <DatePickerControl
                                    sx={{ flex: 1 }}
                                    id="endDate"
                                    control={control}
                                    label="Bitiş Tarihi"
                                    onChange={(date) => {
                                        setValue('endDate', date);
                                    }}
                                />
                            </FormControl>
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={handleSearch}
                                sx={{
                                    height: "56px !important",
                                    borderRadius: '8px',
                                    textTransform: 'none',
                                    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                                }}
                            >
                                Ara
                            </Button>
                        </div>
                        {
                            (parseInt(localStorage.getItem('merchantId') ?? '0') > 0 && showCreate) && (
                                <div className="flex gap-2">

                                    <Tooltip title={'İşlem Yap'}>
                                        <span>
                                            <Button
                                                variant="outlined"
                                                color='success'
                                                onClick={handleOpenGoldBindingModal}
                                                sx={{
                                                    display: mercantIdentification ? 'none !important' : 'block',
                                                    borderRadius: '8px',
                                                    textTransform: 'none',
                                                    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                                                    padding: '6px 16px',
                                                    height: "56px !important",
                                                }}
                                            >
                                                İşlem Yap
                                            </Button>
                                        </span>
                                    </Tooltip>
                                </div>
                            )
                        }
                    </Box>
                </Box>

                <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 2, display: 'flex', justifyContent: 'center' }}>
                    <Tabs
                        value={activeTab}
                        onChange={handleTabChange}
                        sx={{
                            '& .MuiTab-root': {
                                textTransform: 'none',
                                fontSize: '16px',
                                fontWeight: 500
                            }
                        }}
                    >
                        <Tab label="Tüm Altın Bağlantı İşlemleri" />
                        <Tab label="Kalem Bazlı Altın İşlemleri" />
                    </Tabs>
                </Box>

                {activeTab === 0 && tableData && (
                    <Table
                        filterKey="MerchantGoldBindingFormTable"
                        columnVisibilityConfigKey="MerchantGoldBindingFormTableColumnVisibilityKey"
                        hasActiveFilters={hasActiveFilters}
                        handleFilterChange={handleFilterChange}
                        paginationModel={paginationModel}
                        onPaginationModelChange={handleChangePagination}
                        paginationMode="server"
                        rowCount={tableData?.totalItems || 0}
                        isRowSelectable={() => false}
                        customLabelDisplayedRows={true}
                        autoHeight={false}
                        getRowId={() => { return Math.floor(Math.random() * 100000) }}
                        rows={tableData?.result || []}
                        columns={columns}
                        getRowClassName={(params: { row: { status: string } }) => {
                            if (params.row.status === "PASSIVE") return "blocked-row";
                            if (params.row.status === "BLOCKED") return "pasive-row";
                            return "";
                        }}
                        exportFileName="Altın Bağlantı Raporu"
                        onSave={onSave}
                    />
                )}

                {activeTab === 1 && tableDataSecondTab && (
                    <Table
                        filterKey="MerchantBalanceListTable"
                        columnVisibilityConfigKey="MerchantBalanceListTableColumnVisibilityKey"
                        hasActiveFilters={hasActiveFilters}
                        handleFilterChange={handleFilterChange}
                        paginationModel={paginationModelSecondTab}
                        onPaginationModelChange={handleChangePaginationSecondTab}
                        paginationMode="server"
                        rowCount={tableDataSecondTab?.totalItems || 0}
                        isRowSelectable={() => false}
                        customLabelDisplayedRows={true}
                        autoHeight={false}
                        getRowId={() => { return Math.floor(Math.random() * 100000) }}
                        rows={tableDataSecondTab?.result || []}
                        columns={columnsSecondTab}
                        exportFileName="Kalem Bazlı Altın İşlemleri"
                        onSave={onSave}
                    />
                )}
            </Box>

            <GoldBindingModal
                goldBindingOpen={isGoldBindingOpen}
                setGoldBindingOpen={() => {
                    setGoldBindingOpen(false);
                }}
                merchantId='12069'
                key={'gold-binding-modal'}
            />
        </ThemeProvider>

    );
};